import { DOMAIN_REGEX, IAdvertiserDomain, IUpdateAdvertiserDomainParams } from "advertiser/model"
import { advertiserRPO } from "advertiser/repository"
import { translate } from "app/language/service"
import { messageSVC } from "message/service"

export const editAdvertiserDomain = (
  allAdvertiserDomains: IAdvertiserDomain[],
  advertiserDomain: IAdvertiserDomain,
  onEdit: (advertiserDomain: IAdvertiserDomain) => any
) => {
  messageSVC.confirmMessage({
    title: translate("advertiser-domain.edit.title"),
    message: translate("advertiser-domain.message"),
    isInputMessage: true,
    confirmButtonLabel: translate("button.update"),
    defaultInputValue: advertiserDomain.domain,
    validateInput: newDomain => validateAdvertiserDomain(allAdvertiserDomains, newDomain, advertiserDomain.id),
    onSuccessValidation: async newDomain => {
      try {
        onEdit(await updateAdvertiserDomain({ ...advertiserDomain, domain: newDomain }))
        return ""
      } catch (error) {
        console.error(error)
        return translate("advertiser-domain.edit.error.server")
      }
    },
    onSuccess: input => messageSVC.success(translate("advertiser-domain.edit.success", input))
  })
}

export const deleteAdvertiserDomain = (advertiserId: number, advertiserDomainId: number): Promise<void> => {
  return advertiserRPO.deleteAdvertiserDomain(advertiserId, advertiserDomainId)
}

export const createAdvertiserDomain = (advertiserId: number, domain: string): Promise<IAdvertiserDomain> =>
  advertiserRPO.createAdvertiserDomain(advertiserId, {
    advertiser_id: advertiserId,
    domain
  })

export const updateAdvertiserDomain = (params: IUpdateAdvertiserDomainParams): Promise<IAdvertiserDomain> =>
  advertiserRPO.updateAdvertiserDomain(params)

export const validateAdvertiserDomain = (
  allAdvertiserDomains: IAdvertiserDomain[],
  newDomain: string,
  currentAdvertiserDomainId?: number
): string | undefined => {
  if (!newDomain) {
    return translate("label.field.required")
  }
  if (!DOMAIN_REGEX.test(newDomain)) {
    return translate("advertiser-domain.invalid.format")
  }
  if (
    allAdvertiserDomains &&
    allAdvertiserDomains.find(a => a.normalizedName === newDomain && a.id !== currentAdvertiserDomainId)
  ) {
    return translate("advertiser-domain.invalid.already.exist")
  }
}
